<template>
  <button @click="manage()" type="button" class="g--button g--button--block mt-4 w-full">
    Manage plan
  </button>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  text: Text,
  plan: Text,
  period: Text
});

const manage = () => {
  const data = {
    plan: props.plan,
    period: props.period
  };
  data[csrfTokenName] = csrfTokenValue;

  fetch('/actions/live-yoga-teachers/teacher-subscription/get-portal-link', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams(data).toString()
  })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(responseData => {
        if (responseData.url) {
          window.location = responseData.url;
        } else {
          console.log("data", responseData);
        }
      })
      .catch(error => {
        console.error('Error: ', error);
      });
};
</script>